import { toast } from 'react-toastify';

export * from 'react-toastify';
export * from './alert';
export * from './Toasts';
export * from './undo';

/**
 * Show a notification for an unexpected error.
 */
export function toastUnexpectedError(err: Error, options: { prefix?: string } = {}) {
  console.error(options.prefix || '', err);
  const message = options.prefix ? `${options.prefix}: ${err.toString()}` : err.toString();
  toast(message, { type: 'error' });
}
